import { render } from "./InstructionsTable.vue?vue&type=template&id=3efadc5a&ts=true"
import script from "./InstructionsTable.vue?vue&type=script&lang=ts"
export * from "./InstructionsTable.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__